import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["selected"]
const _hoisted_2 = ["selected"]

import { ref } from "vue";
import DbSelect from "../DB-Components/DbSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderHeightInput',
  props: {
  modelValue: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
let selected = ref<number>(props.modelValue);
const emit = __emit;

const handleInput = (event: HTMLInputElement) => {
  let target = event.target as HTMLInputElement;
  const numericValue = parseFloat(target.value.replace(/[^\d]/g, ""));
  const firstTwoDigits = parseFloat(numericValue.toString().substring(0, 2));
  target.value = firstTwoDigits.toString();
  emit("update:modelValue", firstTwoDigits);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DbSelect, {
    required: "",
    modelValue: _unref(selected),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selected) ? (selected).value = $event : selected = $event)),
    value: _unref(selected),
    onChange: handleInput,
    disabled: __props.disabled,
    class: "w-full hydrated",
    name: "height"
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("option", { select: "" }, null, -1)),
      _createElementVNode("option", {
        selected: 86 === _unref(selected),
        value: "86"
      }, "8'6", 8, _hoisted_1),
      _createElementVNode("option", {
        selected: 96 === _unref(selected),
        value: "96"
      }, "9'6", 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["modelValue", "value", "disabled"]))
}
}

})